// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__BJt5-","rowsWrapper":"style_rowsWrapper__sKO7L","rowWrapper":"style_rowWrapper__GFw8r"};